import { render } from "./EmailTeam.vue?vue&type=template&id=141c0868"
import script from "./EmailTeam.vue?vue&type=script&lang=js"
export * from "./EmailTeam.vue?vue&type=script&lang=js"
script.render = render

export default script